import { AccountStore } from './account-store';
import { accountDataService } from '../services/account-data-service';
import { localStorageService } from '../../../shared/services/local-storage-service';
import { uiService } from '../../../shared/services/ui-service';
import { accountSubscription } from '../../../shared/services/account-subscription-service';
import { userService } from '../../../shared/services/user-service';
export const accountStore = new AccountStore(accountDataService, localStorageService, uiService, accountSubscription, userService);
